
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $1a3ac3f530ad9f70$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"oVoOe\",\"SpaceSettingsNavigationPortal.de224852.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.c0800aa9.js\",\"eMbU0\",\"SpaceSelector.7dcf517a.js\",\"3wN5D\",\"ExternalSpaceLozenge.f992c250.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"5RR9C\",\"manual-triggers-modal.b130c0b0.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.895a0429.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.81dc971c.js\",\"7EorR\",\"vendors~editor_atlaskit_md.6b83a527.js\",\"2Stk7\",\"simpleHasher.6d294f6e.js\",\"5vfHd\",\"simpleHasher.runtime.b4f0e216.js\",\"frluw\",\"main.93915f73.js\",\"7cABH\",\"emoji.98f9227f.js\",\"2vAWg\",\"emoji.runtime.923d505b.js\",\"hogcU\",\"component-lazy.d0028dda.js\",\"foy8I\",\"FullPageEditorComponent.3df1b2fe.js\",\"jYUNl\",\"FullPageEditorComponent.runtime.00e5d96e.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"ffEVr\",\"vendors~editor_icon.c84e6fba.js\",\"6aTYS\",\"SpaceSelector.ed3ca1a3.js\",\"lJJQ8\",\"ViewChangesDialog.e8425838.js\",\"8OiWl\",\"ChangesDiff.a64b1265.js\",\"lKP6d\",\"GetTheDetailsYouNeedDark.bbe9839d.gif\",\"4Yi9K\",\"GetTheDetailsYouNeedLight.9900190e.gif\",\"dtpmo\",\"SpaceSelector.ce8265d6.js\",\"6wr18\",\"vendors~editor_icon.6ad0b989.js\",\"jsvF6\",\"NativeCollabComponent.2aa3d973.js\",\"f1Pmi\",\"modal.569913d4.js\",\"jYUNl\",\"FullPageEditorComponent.runtime.00e5d96e.js\",\"2vAWg\",\"emoji.runtime.923d505b.js\",\"5vfHd\",\"simpleHasher.runtime.b4f0e216.js\",\"4yUSc\",\"PremiumLozenge.6931dbeb.js\",\"ePA5l\",\"Lozenge.6e0cd0ae.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"1yVM6\",\"UpgradeEditionButton.dbdacb17.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.7c4f38f4.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"6XCf4\",\"LearnMoreButton.28d22fd5.js\",\"cEqm7\",\"ShareButton.690f8cec.js\",\"7pxAs\",\"EndUserRequestUpgradeModal.1c3723b6.js\",\"7JvFY\",\"CopySpacePermissionsForLegacyNewSpace.e19c566d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.7c4f38f4.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("e4mQI")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.8dcbacd0.js.map
